export default __webpack_public_path__ + "static/media/Direcional_RGB_branco.a827a7d9.png";